/* eslint no-console: ["error", { allow: ["log"] }] */
import axios from 'axios'

class S3Upload {
  constructor (file, options, cancelToken) {
    this.file = file
    this.cancelToken = cancelToken
    this.fileInfo = {
      name: this.file.name,
      type: this.file.type,
      size: this.file.size,
      description: this.file.description,
      lastModifiedDate: this.file.lastModifiedDate
    }
    this.progress = []

    this.onProgressChanged = options.onProgressChanged
    this.onUploadCompleted = options.onUploadCompleted
    this.onServerError = options.onServerError
    this.onS3Error = options.onS3Error
  }

  signS3 () {
    axios.post('sign_s3/', this.fileInfo).then((data) => {
      return this.sendToS3(data.data, this.file)
    }).catch(error => {
      return this.onServerError(error)
    })
  }

  sendToS3 (data, blob) {
    const size = blob.size

    axios.request({
      method: 'PUT',
      headers: '',
      url: data.uploadUrl,
      data: blob,
      cancelToken: this.cancelToken,
      onUploadProgress: (progressEvent) => {
        this.progress = progressEvent.loaded / size * 100
        this.updateProgressBar()
      }
    }).then(() => {
      this.progress = 100
      this.updateProgressBar()
      return this.completeUpload(data)
    }).catch((error) => {
      this.onS3Error(error)
    })
  }

  completeUpload (data) {
    this.fileInfo.key = data.key
    axios.post('complete_upload/', this.fileInfo)
      .then(data => {
        this.onUploadCompleted(data.data)
      }).catch(error => {
        this.onServerError(error)
      })
  }

  updateProgressBar () {
    this.onProgressChanged(this.fileInfo.name, this.progress)
  }
}

export { S3Upload }
